import DatePicker from "react-datepicker";
import styled from "styled-components";

export const FormContainer = styled.div`
  .form {
    justify-content: center;
    padding: 20px;
    width: 100%;
    position: relative;
    .react-datepicker-wrapper {
      width: 100% !important; /* Ensure the wrapper around the date picker takes full width */
    }
  }

  .label-title {
    margin-bottom: 0.5rem;
    font-weight: 700;
    color: #58585b;
    font-size: 0.875rem;
  }
  .error {
    .css-13cymwt-control {
      border-color: #ae1515;
    }
    color: #ae1515;
    &.text-area {
      border: 1px solid #ae1515;
      border-radius: 5px;
    }
  }

  @media only screen and (max-width: 800px) {
    .error {
      font-size: 0.75rem !important;
    }
  }

  .required {
    display: flex;
    color: #ae1515;
    font-size: 0.9375rem;
    gap: 5px;
    margin-left: 5px
  }

  .subtitle {
		word-wrap: break-word;
		color: #666;
		font-style: italic;
		line-height: 1.4;
		white-space: pre-wrap;
		margin-bottom: 10px;
		&.flex {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			button {
				margin-right: 3px;
				gap: 5;
			}
			.add-new {
				font-weight: 400;
			}
			@media only screen and (max-width: 650px) {
				.add-new {
					display: none;
				}
				button {
					gap: 0;
				}
			}
		}
	}
`;

export const CustomBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

export const StyledDatePicker = styled(DatePicker)`
  min-height: 38px;
  outline: 0 !important;
  background-color: hsl(0, 0%, 100%);
  border-radius: 7px;
  border: 1px solid rgb(223, 228, 234);
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  width: 100% !important;
  font-size: 0.875rem;
  padding-left: 10px;
  color: rgb(99, 115, 129);
  &::placeholder {
		-webkit-appearance: none !important;
		appearance: none !important;
		font-size: 0.875rem !important;
		color: #bcbcbc !important;
		opacity: 1 !important;
	}
`;
